<template>
  <div>
    <modal ref="createSignature" class="signature-modal">
      <template #header>
        <h5 class="modal-title mt-0">{{ $t('header.signature.create_signature') }}</h5>
      </template>
      <template #body>
        <form @submit.prevent='createSignatureForm($event)'>

          <div class='modal-body'>
            <div class='form-group'>
              <label>{{ $t('header.signature.title') }}</label>
              <input required='required' type='text' name='request_signature[name]' class='form-control' :placeholder="$t('header.signature.write_title')">
            </div>

            <label>{{$t('header.signature.content')}}</label>
            <div class='form-group'>
              <input id="signature_content" type="hidden" name='request_signature[content]'>
              <trix-editor input="signature_content" name="request_signature[content]"></trix-editor>
            </div>
            <div v-if="showDefaultSignatureCheck">
              <input type='checkbox' name='request_signature[default_value]' />
              {{$t('header.signature.default_one')}}
            </div>
          </div>

          <div class='modal-footer'>
            <input @click.prevent='closeSignatureModals()' type='reset' name='commit' :value="$t('header.cancel')"
                   class='btn btn-neutral'>
            <input type='submit' name='commit' :value="$t('header.save')" class='btn btn-primary'>
          </div>
        </form>
      </template>
    </modal>

    <modal ref='deleteSignature' class="delete-template">
      <template #header>
        <h5 class='modal-title mt-0'>{{ $t('header.signature.delete_signature') }}</h5>
      </template>

      <template #body>
        <div class='modal-body'>
          {{ $t('header.signature.this_will_delete', { signature: signatureToDelete.name }) }}
        </div>

        <div class='modal-footer'>
          <input @click.prevent='closeSignatureModals()' type='reset' :value="$t('header.cancel')"
                 class='btn btn-outline-primary'>
          <input @click.prevent='deleteSignature()' type='submit' :value="$t('header.delete')" class='btn btn-danger'>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
    import _modal from './_modal'
    import 'trix'
    import 'trix/dist/trix.css'

  export default {
      components: {
        'modal': _modal
      },
      data() {
        return {
          signatureToDelete: {}
        }
      },
      computed: {
        signatures() {
          return this.state.signatures || []
        },
        defaultSignature(){
          return this.state.default_signature || null
        },
        showDefaultSignatureCheck(){
          return this.defaultSignature ? false : true
        }
      },
      methods: {
        open(){
            this.$refs.createSignature.open()
        },
        createSignatureForm(e) {
          this.store.createSignature(new FormData(e.target)).then(() => {
            this.store.sendMetrics({name: 'create_signature', params: this.$route.params, path: this.$route.fullPath})
            this.store.getSignatures()
            this.store.getDefaultSignature()
            e.target.reset()
            this.closeSignatureModals()
          })
        },
        closeSignatureModals() {
          this.$refs.createSignature.close()
          this.$refs.deleteSignature.close()
          this.$emit('modalClose')
        },
        deleteSignature() {
          this.store.destroySignature(this.signatureToDelete.id).then(() => {
            this.store.sendMetrics({name: 'remove_signature', params: this.$route.params, path: this.$route.fullPath})
            this.store.getSignatures()
            this.store.getDefaultSignature()
            this.closeSignatureModals()
          })
        },
        openDelete(signature) {
          this.signatureToDelete = Object.assign({}, signature)
          this.$refs.deleteSignature.open()
        }
      }
    }
</script>